import { passosSubmodalidades } from '../../../mocks/worksheet-submodalidades';

export default function PassosSubmodalidades() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Os 8 Passos da Técnica
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Siga este processo para transformar experiências negativas ajustando suas submodalidades
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {passosSubmodalidades.map((passo) => (
            <div
              key={passo.numero}
              className="bg-gradient-to-br from-white to-gray-50 p-6 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100"
            >
              <div className={`w-14 h-14 bg-gradient-to-br ${passo.cor} rounded-xl flex items-center justify-center mb-4`}>
                <i className={`${passo.icone} text-white text-2xl`}></i>
              </div>
              
              <div className="flex items-center gap-2 mb-3">
                <span className="text-sm font-bold text-gray-400">PASSO {passo.numero}</span>
              </div>
              
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {passo.titulo}
              </h3>
              
              <p className="text-sm text-gray-600 leading-relaxed">
                {passo.descricao}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-gradient-to-r from-amber-50 to-orange-50 border-l-4 border-amber-500 p-6 rounded-xl">
          <div className="flex items-start gap-3">
            <i className="ri-lightbulb-line text-amber-600 text-2xl flex-shrink-0 mt-1"></i>
            <div>
              <p className="font-semibold text-amber-900 mb-1">Dica Importante:</p>
              <p className="text-sm text-amber-800">
                Os "drivers críticos" são as submodalidades que têm maior impacto emocional quando alteradas. Eles são únicos para cada pessoa — experimente para descobrir os seus!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}